<template>
  <div v-show.async="show">
    <div class="panel mt-20">
      <ul class="collections">
        <li class="flex-row-between">
          <span class="title">待收款</span>
          <span style="font-size: 20px" class="text-danger">
            ￥{{
              Math.max(
                order.order_info.amount - order.collection_total,
                0
              ).toLocaleString()
            }}
          </span>
        </li>
        <li>
          <el-progress
            :text-inside="true"
            :stroke-width="18"
            status="success"
            :percentage="order.collection_percentage"
          ></el-progress>
        </li>
        <li class="flex-row-between">
          <span class="title">已收款</span>
          <span class="text-success"
            >￥{{ order.collection_total.toLocaleString() }}</span
          >
        </li>
      </ul>
    </div>
    <div class="panel mt-20">
      <div class="header flex-row-between">
        <h2>费用记录</h2>
        <el-button
          v-if="order.deleted == 0"
          class="ml-10"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="startOrderCostFormer()"
          v-permission="Auth.orderExpenseNew"
          >新费用</el-button
        >
      </div>
      <el-table
        v-if="!isMobile()"
        :data="orderCosts"
        style="width: 100%"
        key="orderCosts"
      >
        <el-table-column prop="type" label="费用类型"></el-table-column>
        <el-table-column
          prop="amount"
          label="费用金额"
          width="160"
        ></el-table-column>
        <el-table-column prop="date" label="日期" width="160">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.date) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <div class="flex-row-between">
              <el-button
                type="danger"
                size="mini"
                plain
                @click="deleteOrderCost(scope.$index)"
                v-permission="Auth.orderExpenseDelete"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startOrderCostFormer(scope.row, scope.$index)"
                v-permission="Auth.orderExpenseEdit"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in orderCosts">
          <div class="flex-row-between">
            <span>{{ item.type }}</span>
            <span>{{ item.amount }}</span>
          </div>
          <div class="text-info-12">
            <span>{{ formatTime(item.date) }}</span>
          </div>
          <div>
            <el-button
              type="danger"
              size="mini"
              plain
              @click="deleteOrderCost(index)"
              v-permission="Auth.orderExpenseDelete"
              >删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              plain
              @click="startOrderCostFormer(item, index)"
              v-permission="Auth.orderExpenseEdit"
              >修改</el-button
            >
          </div>
        </li>
      </ul>
      <div v-if="orderCosts.length == 0 && isMobile()" class="text-info-12">
        还未添加费用记录。
      </div>
    </div>
    <div class="panel mt-20" v-if="order.status >= 10">
      <div class="header flex-row-between">
        <h2>回款记录</h2>
        <el-button
          v-if="order.deleted == 0"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="startCollectionFormer()"
          v-permission="Auth.orderPayBackNew"
          >添加回款</el-button
        >
      </div>
      <el-table
        v-if="!isMobile()"
        :data="collections"
        style="width: 100%"
        key="collections"
      >
        <el-table-column prop="amount" label="回款金额">
          <template slot-scope="scope">
            <span>￥{{ math.show(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="回款日期">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.date) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <div class="flex-row-between">
              <el-button
                type="danger"
                size="mini"
                plain
                @click="deleteCollection(scope.$index)"
                v-permission="Auth.orderPayBackDelete"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                plain
                @click="startCollectionFormer(scope.row, scope.$index)"
                v-permission="Auth.orderPayBackEdit"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in collections">
          <div class="flex-row-between">
            <span>￥{{ math.show(item.amount) }}</span>
            <span>{{ formatTime(item.date) }}</span>
          </div>
          <div>
            <el-button
              type="danger"
              size="mini"
              plain
              @click="deleteCollection(index)"
              v-permission="Auth.orderPayBackDelete"
              >删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              plain
              @click="startCollectionFormer(item, index)"
              v-permission="Auth.orderPayBackEdit"
              >修改</el-button
            >
          </div>
        </li>
      </ul>
      <div v-if="collections.length == 0 && isMobile()" class="text-info-12">
        暂无回款记录
      </div>
    </div>
    <template v-else>
      <div class="panel mt-20 text-gray">订单审批后可添加回款</div>
    </template>
    <order-cost
      :show.sync="orderCostFormerVisible"
      :model="orderCostForm"
      @created="createdOrderCost"
      @updated="updatedOrderCost"
    ></order-cost>
    <customer-collection-former
      :model="customerCollectionForm"
      :order="order"
      :show.sync="customerCollectionFormVisible"
      @created="createdCustomerCollection"
      @updated="updatedCustomerCollection"
    ></customer-collection-former>
  </div>
</template>

<script>
import { formatTime } from '@/util/index'
import CustomerCollectionFormer from '@/components/customer_collection'
import OrderCost from '@/components/order_cost'
import {
  orderCostList,
  customerCollectionList,
  deleteOrderCost,
} from '../../service/getData'
import { clone } from '@/util'
import math from '../../util/math'
import { isMobile } from '../../util'

export default {
  components: { OrderCost, CustomerCollectionFormer },
  props: {
    order: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      math,
      isMobile,
      orderCosts: [],
      formatTime,
      orderCostFormerVisible: false,
      orderCostForm: {},
      customerCollectionForm: {},
      customerCollectionFormVisible: false,
      editOrderCostIndex: 0,
      collections: [],
      editCollectionIndex: 0,
    }
  },
  watch: {
    show() {
      if (this.show && this.collections.length == 0) {
        this.requestCustomerCollections()
      }
    },
  },
  created() {
    this.requestOrderCosts()
    if (this.show) {
      this.requestCustomerCollections()
    }
  },
  methods: {
    async requestOrderCosts() {
      let data = {
        customer_order_id: this.order.id,
      }
      let res = await orderCostList(data)
      if (res.code == 0) {
        this.orderCosts = res.data.list
        this.$parent.recalculateCost(this.orderCosts)
      }
    },
    async requestCustomerCollections() {
      let res = await customerCollectionList({
        customer_order_id: this.order.id,
      })
      if (res.code == 0) {
        this.collections = res.data.list
      }
    },
    startOrderCostFormer(orderCost, index) {
      if (orderCost) {
        this.editOrderCostIndex = index
        this.orderCostForm = clone(orderCost)
      } else {
        this.orderCostForm = {
          order: this.order,
          customer_order_id: this.order.id,
          date: new Date(),
          amount: null,
          type: null,
        }
      }
      this.orderCostFormerVisible = true
    },
    createdOrderCost(orderCost) {
      this.orderCosts.unshift(orderCost)
      this.$parent.recalculateCost(this.orderCosts)
    },
    updatedOrderCost(orderCost) {
      this.orderCosts.splice(this.editDeviceIndex, 1, orderCost)
      this.$parent.recalculateCost(this.orderCosts)
    },
    deleteOrderCost(index) {
      let oc = this.orderCosts[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteOrderCost(oc.id).then((res) => {
          if (res.code == 0) {
            that.orderCosts.splice(index, 1)
            that.$parent.recalculateCost(this.orderCosts)
          }
        })
      })
    },
    createdCustomerCollection(collection) {
      this.collections.unshift(collection)
      this.updateOrderCollection()
    },
    updatedCustomerCollection(collection) {
      this.collections.splice(this.editCollectionIndex, 1, collection)
      this.updateOrderCollection()
    },
    updateOrderCollection() {
      var total = 0
      this.collections.map((i) => {
        total = math.add(total, parseFloat(i.amount))
      })
      this.order.collection_total = total
      this.order.collection_percentage = Math.min(
        parseInt(
          (this.order.collection_total / this.order.order_info.amount) * 100
        ),
        100
      )
    },
    startCollectionFormer(collection, index) {
      if (collection) {
        this.customerCollectionForm = clone(collection)
        this.editCollectionIndex = index
      } else {
        this.customerCollectionForm = {
          customer_id: this.order.customer_id,
          amount: '',
          customer_order_id: this.order.id,
          date: null,
        }
      }
      this.customerCollectionFormVisible = true
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
.collections li {
  padding: 3px 0;
}

.collections li span {
  color: #323232;
  font-size: 14px;
}
.collections li span.title {
  font-size: 12px;
  color: #999;
}
</style>